import { Route } from '../interfaces/router.interface';
import { Filter } from '../models/filter';
import { AllowedFilterCombinationsPolicy } from '../models/indexability';
import { BaseRouteHandler } from './BaseRouteHandler';
import { IRouteHandler } from './IRouteHandler';
import RoutingDefinitions from './RoutingDefinitions';

export class PortalRouteHandler extends BaseRouteHandler implements IRouteHandler {
	public canHandle(filters: Filter[]): boolean {
		return AllowedFilterCombinationsPolicy.notSatisfiedBy(filters);
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	protected selectRoute(filters: Filter[]): Route {
		return {
			name: RoutingDefinitions.PORTAL_ROUTE
		};
	}
}
